import styled from "styled-components";


export const LeaveWrapper = styled.div<{isMobile: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
  max-width: 390px;
  margin: auto;

  ${({isMobile}) => !isMobile && `
    margin: auto;
    height: calc(100vh - 100px);
  `};
`;